/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PayrollActionType {
  CHANGE_AMOUNTS = 'CHANGE_AMOUNTS',
  CHANGE_AMOUNTS_MID_MONTH = 'CHANGE_AMOUNTS_MID_MONTH',
  ADD_AMOUNTS = 'ADD_AMOUNTS',
  REMOVE_AMOUNTS = 'REMOVE_AMOUNTS',
  REMOVE_AMOUNTS_MID_MONTH = 'REMOVE_AMOUNTS_MID_MONTH',
  RETROACTIVE_CHANGE = 'RETROACTIVE_CHANGE',
}
